import { GPIO_ENTITY_EVENTS, getGpioEventChoices } from '../Hasp/properties/v2/logic/index.js';

/**
 * GPIO entity nodes in the logic graph: a node `{ type: 'gpio', data: { entity } }`
 * is an event source like a UI object. The entity's metadata (domain) is only
 * known to the editor; `context.getGpioEntity(id)` supplies it when available.
 */
export const isGpioNode = node => node?.type === 'gpio';

/** Events a GPIO node offers. */
export function gpioNodeEventChoices(gpioNode, context = {}) {
    return getGpioEventChoices(context.getGpioEntity?.(gpioNode?.data?.entity) ?? null);
}

/**
 * A stand-in source object for the action editors, which resolve event values
 * ({val}) and targets from a source object: GPIO events with their payload,
 * targets on `page`.
 */
export function gpioEditorSource(page, gpioNode) {
    return {
        obj: 'gpio',
        haspid: 0,
        comment: `GPIO ${gpioNode?.data?.entity ?? ''}`,
        schemaV2: { events: GPIO_ENTITY_EVENTS },
        actions: [],
        parent: page,
        getParent: () => page,
        getLayer: () => page?.getLayer?.(),
    };
}
